import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  BankInterestDto,
  BankInterestListDto,
  BankInterestFilterDto,
  CreateBankInterestRequest,
  UpdateBankInterestRequest,
} from '@/types/bankInterest.types';

export const bankInterestApi = {
  /** GET /api/v1/bank-interests — paginated list */
  getList: (filter?: BankInterestFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<BankInterestListDto>>>('/bank-interests', { params: filter }),

  /** GET /api/v1/bank-interests/{id} — full bank interest detail */
  getById: (id: string) =>
    apiClient.get<ApiResponse<BankInterestDto>>(`/bank-interests/${id}`),

  /** POST /api/v1/bank-interests — create new bank interest (Draft) */
  create: (data: CreateBankInterestRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/bank-interests', data),

  /** PUT /api/v1/bank-interests/{id} — update draft bank interest */
  update: (id: string, data: UpdateBankInterestRequest) =>
    apiClient.put<ApiResponse<object>>(`/bank-interests/${id}`, data),

  /** POST /api/v1/bank-interests/{id}/submit — submit for approval */
  submit: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-interests/${id}/submit`),

  /** POST /api/v1/bank-interests/{id}/approve — approve the bank interest */
  approve: (id: string, remarks?: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-interests/${id}/approve`, { remarks }),

  /** POST /api/v1/bank-interests/{id}/reject — reject with reason */
  reject: (id: string, reason: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-interests/${id}/reject`, { reason }),

  /** POST /api/v1/bank-interests/{id}/post — post to general ledger */
  post: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-interests/${id}/post`),

  /** POST /api/v1/bank-interests/{id}/reverse — create reversal bank interest */
  reverse: (id: string, reversalDate: string, reversalPostingDate: string, narration?: string) =>
    apiClient.post<ApiResponse<{ id: string }>>(`/bank-interests/${id}/reverse`, {
      reversalDate,
      reversalPostingDate,
      narration,
    }),

  /** POST /api/v1/bank-interests/{id}/cancel — cancel the bank interest */
  cancel: (id: string, reason?: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-interests/${id}/cancel`, { reason }),

  /** DELETE /api/v1/bank-interests/{id} — soft-delete (draft only) */
  delete: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/bank-interests/${id}`),
};
